export default "__VITE_PUBLIC_ASSET__50b67c68__"